/**
 * Parser for POST `/earn/vaults/queue`. Composes the shared withdrawal-request parser
 * from {@link ./earn-positions-parser}.
 */

import { EarnQueueResponseApi } from "../api/earn-queue";
import { EarnQueueResponse } from "../domain/earn-queue";
import { parseEarnWithdrawalRequestFromApi } from "./earn-positions-parser";

export function parseEarnQueueResponseFromApi(api: EarnQueueResponseApi): EarnQueueResponse {
    return {
        pageInfo: api.pageInfo,
        openRequests: api.openRequests.map(parseEarnWithdrawalRequestFromApi),
        depthShares: BigInt(api.depthShares),
        fulfilledUnclaimedShares: BigInt(api.fulfilledUnclaimedShares)
    };
}
